import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e142317"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_2 = { class: "d-flex align-items-center mb-0" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "w-200px" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Apply", -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { style: {"width":"80px"} }

import { ref, watch } from "vue";
import { Field } from "vee-validate";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'CategorySymbolsCollapse',
  props: {
    schema: {},
    formTab: {},
    applyCategoryForm: {},
    initialCollapsed: { type: Boolean }
  },
  emits: ["update-symbol", "apply-category", "update-apply-input"],
  setup(__props: any, { emit: emits }) {

const props = __props;

useI18n();





const collapsed = ref<Record<string, boolean>>({});
const localApply = ref<Record<string, Record<string, any>>>({
  rate: {},
  pips: {},
  commission: {},
  bundleVal: {},
});

// Modified init: do NOT reset collapsed each time; only assign defaults for new categories
const init = () => {
  Object.keys(props.schema || {}).forEach((c) => {
    if (collapsed.value[c] === undefined) {
      collapsed.value[c] = props.initialCollapsed !== false;
    }
    ["rate", "pips", "commission", "bundleVal"].forEach((tab) => {
      if (!localApply.value[tab]) localApply.value[tab] = {};
      if (props.applyCategoryForm?.[tab]?.[c] !== undefined) {
        localApply.value[tab][c] = props.applyCategoryForm[tab][c];
      } else if (localApply.value[tab][c] === undefined) {
        localApply.value[tab][c] = "";
      }
    });
  });
};

watch(
  () => props.schema,
  () => init(),
  { deep: true, immediate: true }
);

watch(
  () => props.applyCategoryForm,
  () => {
    Object.keys(props.applyCategoryForm || {}).forEach((tab) => {
      Object.keys(props.applyCategoryForm[tab] || {}).forEach((cat) => {
        localApply.value[tab][cat] = props.applyCategoryForm[tab][cat];
      });
    });
  },
  { deep: true }
);

const toggle = (cat: string) => {
  collapsed.value[cat] = !collapsed.value[cat];
};

const emitUpdateSymbol = (category: string, symbolKey: string, value: any) => {
  emits("update-symbol", {
    category,
    symbolKey,
    formTab: props.formTab,
    value,
  });
};

const onApplyInput = (category: string, value: any) => {
  localApply.value[props.formTab][category] = value;
  emits("update-apply-input", { category, formTab: props.formTab, value });
};

const applyCategory = (category: string) => {
  emits("apply-category", {
    category,
    formTab: props.formTab,
    value: localApply.value[props.formTab][category],
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema, (symbols, category) => {
    return (_openBlock(), _createElementBlock("div", {
      key: category,
      class: "mb-7 p-7",
      style: {"box-shadow":"rgba(99, 99, 99, 0.2) 0 2px 8px 0"}
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, [
          _createElementVNode("button", {
            class: "collapse-toggle me-2",
            type: "button",
            onClick: ($event: any) => (toggle(category))
          }, [
            (collapsed.value[category])
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "+"))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
          ], 8, _hoisted_3),
          _createTextVNode(" " + _toDisplayString(category), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(Field), {
            "model-value": localApply.value[_ctx.formTab][category],
            class: "form-control form-control-lg form-control-solid",
            type: "text",
            name: "applyCategory",
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                "model-value": localApply.value[_ctx.formTab][category],
                placeholder: _ctx.$t('tip.pleaseInput'),
                size: "large",
                "onUpdate:modelValue": (val) => onApplyInput(category, val)
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    onClick: _withModifiers(($event: any) => (applyCategory(category)), ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1032, ["model-value", "placeholder", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["model-value"])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(symbols, (symbol, symbolKey) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-4 mt-5",
            key: symbolKey
          }, [
            _createVNode(_unref(Field), {
              "model-value": symbol[_ctx.formTab],
              class: "form-control form-control-lg form-control-solid",
              type: "number",
              name: "symbolRule",
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  "model-value": symbol[_ctx.formTab],
                  size: "large",
                  "onUpdate:modelValue": 
              (val) => emitUpdateSymbol(category, symbolKey, val)
            
                }, {
                  prepend: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", null, _toDisplayString(symbol.symbolCode), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["model-value", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["model-value"])
          ]))
        }), 128))
      ], 512), [
        [_vShow, !collapsed.value[category]]
      ])
    ]))
  }), 128))
}
}

})